/*
 * Timeline
 * MIT  https://github.com/rsuite/rsuite/blob/master/src/Timeline/Timeline.tsx
 */
import Timeline from './Timeline';
export default Timeline;